import { render, staticRenderFns } from "./page-reminder.vue?vue&type=template&id=33bc4020"
import script from "./page-reminder.vue?vue&type=script&lang=ts"
export * from "./page-reminder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports